import React from 'react';
import AbsoluteLink from 'components/Common/AbsoluteLink';

const Logo = () => (
  <AbsoluteLink>
    <img
      alt="Ki Niseko logo"
      height="124"
      src="https://www.kiniseko.com/assets/img/logo@2x.png"
      width="139"
    />
  </AbsoluteLink>
);

export default Logo;
